module.exports = __webpack_public_path__ + "static/img/119.5f7b6de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/119.png
// module id = X3fm
// module chunks = 0